export class CabSeguiModel {

    codCliente: string;
    nomCliente: string;
    direccion: string;
    horaEstimada: string;
    estadoRuta: string;
    ciudad: string;
    esquema: string;
    direccionEsquema: string;
  
    constructor(
        codCliente?,
        nomCliente?,
        direccion?,
        horaEstimada?,
        estadoRuta?,
        ciudad?,
        esquema?,
        direccionEsquema?
                ) {
      this.codCliente = codCliente;
      this.nomCliente = nomCliente;
      this.direccion =  direccion;
      this.horaEstimada = horaEstimada;
      this.estadoRuta =  estadoRuta;
      this.ciudad = ciudad;
      this.esquema = esquema;
      this.direccionEsquema = direccionEsquema;
    }
  
  }